
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 101 101"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 6","transform":"translate(0 -.439)","fill":"none","d":"M0 0h101v101H0z"}})])]),_c('g',{attrs:{"data-name":"2020 VW Logo White RGB Reg"}},[_c('g',{attrs:{"data-name":"Group 13","transform":"translate(0 .439)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 38","d":"M50.253 73.147a22.89 22.89 0 01-22.789-22.84 22.286 22.286 0 011.459-8l13.331 26.816a.822.822 0 001.61 0l6.135-13.734c.05-.151.151-.3.3-.3s.2.151.3.3l6.138 13.734a.822.822 0 001.61 0l13.337-26.814a22.337 22.337 0 011.459 8 22.89 22.89 0 01-22.89 22.84m0-28.021c-.151 0-.2-.151-.3-.3l-7.144-16.1a21.984 21.984 0 0114.891 0l-7.144 16.1c-.05.151-.151.3-.3.3m-7.298 16.549c-.151 0-.2-.151-.3-.3L31.086 38.033a23.544 23.544 0 018.2-7.7l8.351 18.513a.6.6 0 00.6.453h4.025a.6.6 0 00.654-.4l8.351-18.563a23.544 23.544 0 018.2 7.7L57.799 61.375c-.05.151-.151.3-.3.3s-.2-.151-.3-.3l-4.381-9.961a.6.6 0 00-.654-.4H48.24a.6.6 0 00-.654.4l-4.326 9.961c-.05.151-.151.3-.3.3m7.295 13.784a25.1 25.1 0 10-17.8-7.353 25.154 25.154 0 0017.8 7.353","fill":"#fff"}})])])])
          )
        }
      }
    